import { getConfig } from 'owa-service/lib/config';

/**
 * Prepends the service base URL
 * @param serviceUrl The service URL to prepend the base url to. It should start with `/`
 */
export default function prependServiceBaseUrl(serviceUrl: string): string {
    const config = getConfig();
    return config.baseUrl ? `${config.baseUrl}${serviceUrl}` : `/owa${serviceUrl}`;
}
